import React from 'react';
// import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './NewCircleModalSearch.scss';

import CuratorCardNew from '../../../Curators/CuratorCardNew';
import InputActions from '../../../General/InputActions';

import { fetchAlgoliaIndex } from '../../../../Helpers/search_helpers';
import { getPopularCurators } from '../../../../APIClient/shop';
const NewCircleModalSearch = props => {
  const { selectedCurators } = props;

  const [curSearchVal, setCurSearchVal] = React.useState('');
  const [isFetching, setIsFetching] = React.useState(true);
  const [searchResults, setSearchResults] = React.useState([]);
  const [initialCurators, setInitialCurators] = React.useState([]);

  const debounceSearch = React.useRef(null);
  const storeSearchIndexRef = React.useRef(fetchAlgoliaIndex(`store_${window.__IS_PROD__ ? 'production' : 'staging'}`));

  // Fetch batch of popular curators for empty state
  React.useEffect(() => {
    getPopularCurators({ limit: 50 })
      .then(resp => setInitialCurators(resp.curators))
      .catch(() => window.ALERT.error('There was an issue loading popular curators.'))
      .finally(() => setIsFetching(false));
  }, []);

  // Fetch curators from Algolia on search term
  React.useEffect(() => {
    if (curSearchVal) {
      setIsFetching(true);
      debounceSearch.current = setTimeout(() => {
        window.__ADD_EVENT__('Shop - New Circle Modal - Search', { searchVal: curSearchVal });

        storeSearchIndexRef.current
          .search(curSearchVal, {
            page: 0,
            facetFilters: [['type:Curator']],
            hitsPerPage: 25
          })
          .then(({ hits }) => setSearchResults(hits))
          .catch(() => window.ALERT.error('There was an error, please try again.'))
          .finally(() => setIsFetching(false));
      }, 250);
      return () => {
        clearTimeout(debounceSearch.current);
      };
    } else {
      setSearchResults([]);
    }
  }, [curSearchVal]);

  const isFetchingInitialResults = isFetching && !searchResults.length && !initialCurators.length;
  const isFetchingInitialSearchResults = isFetching && !!curSearchVal && !searchResults.length;
  const hasNoResults = !isFetching && !searchResults.length && !!curSearchVal;

  const inputRef = React.useRef(null);
  const resetSearch = () => {
    setCurSearchVal('');
    inputRef.current && inputRef.current.focus();
  };

  // Actions
  const toggleCurator = curator => {
    const isSelected = selectedCurators.some(sc => sc.id === curator.id);
    isSelected
      ? props.setSelectedCurators(selectedCurators.filter(sc => sc.id !== curator.id))
      : props.setSelectedCurators([...selectedCurators, curator]);
  };

  const additionalClasses = { fetching: isFetching };
  return (
    <div className='new-circle-modal-search-container'>
      <div className='search-header'>
        <div className='search-input-container has-actions'>
          <InputActions searchVal={curSearchVal} onCancel={resetSearch} />
          <input
            ref={inputRef}
            type='text'
            placeholder='What ShopMy curator are you looking for?'
            autoFocus
            value={curSearchVal}
            onChange={e => setCurSearchVal(e.target.value)}
          />
        </div>
      </div>
      {hasNoResults ? (
        <div className='no-results'>
          <div className='title'>No curators found with the name or social handle of "{curSearchVal}"</div>
          <div className='description'>
            We only allow searching for curators who pass our Trendsetter or Icon threshold, to add other curators to your circle, please ask them to
            send you their shop profile and you can use the heart to add them to your circle.
          </div>
        </div>
      ) : (
        <div className={cn('search-results', additionalClasses)}>
          {isFetchingInitialResults || isFetchingInitialSearchResults
            ? _.range(16).map(idx => <div className='search-result loading' key={idx} />)
            : !curSearchVal
            ? initialCurators.map(initialCurator => {
                const curator = {
                  id: initialCurator.id,
                  image: initialCurator.image,
                  name: initialCurator.name,
                  username: initialCurator.username,
                  social_links: initialCurator.social_links
                };
                const isSelected = selectedCurators.some(sc => sc.id === curator.id);
                const isAnotherSelected = !isSelected && !!selectedCurators.length;
                return (
                  <CuratorCardNew
                    curator={curator}
                    isLoading={isFetching}
                    isSelectable
                    isSelected={isSelected}
                    isAnotherSelected={isAnotherSelected}
                    onToggle={() => toggleCurator(curator)}
                    searchResultCurator={curator}
                    key={curator.id}
                  />
                );
              })
            : searchResults.map(algoliaCurator => {
                const curator = {
                  id: algoliaCurator.Curator_id,
                  image: algoliaCurator.image,
                  name: algoliaCurator.highlightedParts?.[0] || algoliaCurator.term,
                  username: algoliaCurator.Curator_username
                };
                const isSelected = selectedCurators.some(sc => sc.id === curator.id);
                const isAnotherSelected = !isSelected && !!selectedCurators.length;

                const toggle = () => toggleCurator(curator);

                return (
                  <CuratorCardNew
                    curator={curator}
                    isLoading={isFetching}
                    isSelectable
                    isSelected={isSelected}
                    isAnotherSelected={isAnotherSelected}
                    onToggle={toggle}
                    searchResultCurator={curator}
                    key={curator.id}
                  />
                );
              })}
        </div>
      )}
    </div>
  );
};

NewCircleModalSearch.propTypes = {
  shop: PropTypes.object.isRequired,
  selectedCurators: PropTypes.array.isRequired,
  closeSearch: PropTypes.func.isRequired
};

export default NewCircleModalSearch;
